// extracted by mini-css-extract-plugin
export default {"container":"ResultAnnotations_container__hr-9s","text":"ResultAnnotations_text__MHyke","selected":"ResultAnnotations_selected__Yt6f5"};